
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { BlogManagement } from './blog/BlogManagement';
import { AdminManagement } from './AdminManagement';
import { CalendarAnalytics } from './admin/CalendarAnalytics';
import { SystemDiagnostics } from './admin/SystemDiagnostics';
import { WorkshopAdmin } from './admin/WorkshopAdmin';
import { Shield, FileText, Calendar, Settings, Camera } from 'lucide-react';

export const AdminDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState('calendars');

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <TabsList className="grid w-full grid-cols-5 mb-8">
        <TabsTrigger value="calendars" className="flex items-center gap-2">
          <Calendar className="w-4 h-4" />
          Calendars
        </TabsTrigger>
        <TabsTrigger value="blog" className="flex items-center gap-2">
          <FileText className="w-4 h-4" />
          Blog
        </TabsTrigger>
        <TabsTrigger value="workshops" className="flex items-center gap-2">
          <Camera className="w-4 h-4" />
          Workshops
        </TabsTrigger>
        <TabsTrigger value="admins" className="flex items-center gap-2">
          <Shield className="w-4 h-4" />
          Admins
        </TabsTrigger>
        <TabsTrigger value="system" className="flex items-center gap-2">
          <Settings className="w-4 h-4" />
          System
        </TabsTrigger>
      </TabsList>

      <TabsContent value="calendars">
        <CalendarAnalytics />
      </TabsContent>

      <TabsContent value="blog">
        <BlogManagement />
      </TabsContent>

      <TabsContent value="workshops">
        <WorkshopAdmin />
      </TabsContent>

      <TabsContent value="admins">
        <AdminManagement />
      </TabsContent>

      <TabsContent value="system">
        <SystemDiagnostics />
      </TabsContent>
    </Tabs>
  );
};
